import * as React from "react";
const SvgEmoticonFrown20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm2.587 12.88.506.862 1.725-1.013-.507-.862a5 5 0 0 0-8.594-.047l-.516.856 1.713 1.032.516-.856a3 3 0 0 1 5.157.028ZM8 8.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm5.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
      clipRule: "evenodd"
    })
  );
export default SvgEmoticonFrown20Px;
